module.exports = __webpack_public_path__ + "a5fdc4c0e1b38ca4c80e0d8b7648b658.MP3";